import {Component, effect, HostListener, inject} from '@angular/core';
import {Route, Router, RouterModule, RouterOutlet} from '@angular/router';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {routes} from "./app.routes";
import {MenuitemComponent} from "./components/app/layout/menuitem/menuitem.component";
import {IconComponent} from "./components/app/layout/icon/icon.component";
import {AsyncPipe, CommonModule} from "@angular/common";
import {StyleClassModule} from "primeng/styleclass";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {ProgressBarModule} from "primeng/progressbar";
import {HttpLoadingService} from "./services/app/http-loading.service";
import {ToastModule} from "primeng/toast";
import {ButtonDirective} from "primeng/button";
import Keycloak from 'keycloak-js';
import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, ReadyArgs, typeEventArgs} from "keycloak-angular";
import {Permission} from "./interfaces/permission";
import {AuthService} from "./services/app/auth.service";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterModule, RouterOutlet, FontAwesomeModule, MenuitemComponent, IconComponent, AsyncPipe, StyleClassModule, ConfirmPopupModule, ProgressBarModule, ToastModule, ButtonDirective],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    @HostListener('window:scroll', ['$event']) onScrollEvent($event: Event) {
        this.topbarIsSticky = window.scrollY > 20;
    }

    private keycloak = inject(Keycloak);
    private keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

    protected readonly routes: Route[] = routes;
    protected darkMode: boolean = true;
    protected topbarIsSticky: boolean = false;
    protected extendSidebar: boolean = false;
    protected isAuthenticated: boolean = false;

    constructor(
        protected readonly router: Router,
        protected readonly httpLoadingService: HttpLoadingService,
        protected auth: AuthService
    ) {
        this.router.events.subscribe((route) => {
            this.extendSidebar = false;
        });

        effect(() => {
            const keycloakEvent = this.keycloakSignal();

            if (keycloakEvent.type === KeycloakEventType.Ready) {
                this.isAuthenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
            }
            if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
                this.isAuthenticated = false;
            }
        });
    }

    login(): void {
        this.keycloak.login();
    }

    logout(): void {
        this.keycloak.logout();
        window.location.reload();
    }

    toggleDarkMode(): void {
        this.darkMode = !this.darkMode;

        const element = document.querySelector('html');
        element?.classList.toggle('dark');
    }

    protected readonly Permission = Permission;
}
